export default "<json-editor class=\"h-100\" [options]=\"editorOptions\" [data]=\"jsonValue\" ></json-editor>";